import { useQuery } from '@tanstack/react-query';
import { eatsKeys, restaurantApi } from '@noor/eats-api';

/**
 * Read one branch with every translation plus its stored schedule, for seeding
 * the editor. Idle when `id` is undefined — a create has nothing to read.
 *
 * `GET /restaurants/{id}/by-merchant` answers with a `v1LocalizedRestaurant`,
 * so the three «Описание» inputs are each filled from their own translation
 * rather than from one locale-resolved string.
 *
 * `staleTime: 0` so every open re-reads. On the app-wide 30s default, reopening
 * the same branch inside that window served the cached record with no refetch —
 * `dataUpdatedAt` never advanced, so the form seeded from a copy that could be
 * up to 30 seconds behind whatever a moderator (or another session) had since
 * changed, and saving wrote that back.
 */
export function useBranchDetails(id: string | undefined) {
  return useQuery({
    // Distinct from `eatsKeys.restaurants.detail`, which caches the
    // locale-resolved read — same id, different shape, so they must not share
    // a cache entry.
    queryKey: [...eatsKeys.restaurants.detail(id ?? ''), 'localized'],
    queryFn: ({ signal }) => restaurantApi.getLocalizedWithSchedule(id!, { signal }),
    enabled: id !== undefined,
    staleTime: 0,
  });
}
